import { Button } from '@/components/ui/button';
import { ArrowLeft, ArrowRight, Check, AlertCircle } from 'lucide-react';

export const CustomizationFooterBar = ({
  hasPrevious,
  hasNext,
  canGoNext,
  canSubmit,
  missingCount = 0,
  onPrevious,
  onNext,
  onCancel,
  onSubmit,
  submitLabel = 'Save',
  isSubmitting = false,
}) => {
  return (
    <div className="rounded-2xl border border-slate-200 bg-white/95 p-3 backdrop-blur shrink-0" data-testid="customization-footer-bar">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wide text-slate-500">
          <span data-testid="customization-mode-guided-label">Guided Mode</span>
          {missingCount > 0 && (
            <span
              className="inline-flex items-center gap-1 rounded-full bg-red-50 px-2 py-0.5 text-[11px] font-semibold normal-case tracking-normal text-red-600"
              data-testid="customization-missing-required-badge"
            >
              <AlertCircle className="h-3 w-3" />
              {missingCount} required field{missingCount > 1 ? 's' : ''} missing
            </span>
          )}
        </div>

        <div className="flex flex-wrap items-center gap-2">
          <Button type="button" variant="outline" onClick={onCancel} data-testid="customization-cancel-button">
            Cancel
          </Button>

          <Button
            type="button"
            variant="outline"
            onClick={onPrevious}
            disabled={!hasPrevious}
            data-testid="customization-previous-button"
          >
            <ArrowLeft className="mr-1 h-4 w-4" />
            Previous
          </Button>
          <Button
            type="button"
            variant="outline"
            onClick={onNext}
            disabled={!hasNext || !canGoNext}
            data-testid="customization-next-button"
          >
            Next
            <ArrowRight className="ml-1 h-4 w-4" />
          </Button>

          <Button
            type="button"
            onClick={onSubmit}
            disabled={isSubmitting}
            className={!canSubmit ? 'opacity-60' : ''}
            title={!canSubmit ? 'Some required fields are missing - click to see which ones' : undefined}
            data-testid="customization-submit-button"
          >
            <Check className="mr-1 h-4 w-4" />
            {isSubmitting ? 'Saving...' : submitLabel}
          </Button>
        </div>
      </div>
    </div>
  );
};
